<div class="invite-icon">
  <se-fe-icon
    seFeDataName="spot_family"
    seFeDataSize="950"
    seFeDataAriaLabel="success">
  </se-fe-icon>
</div>
@if (invites?.length > 1) {
  <div class="invite-description">{{ translationKey + "invite_review_plural" | translate }}</div>
}
@if (invites?.length === 1) {
  <div class="invite-description">{{ translationKey + "invite_review" | translate }}</div>
}
@for (invite of invites; track invite) {
  <div class="invite-content">
    <se-po-guardian-invite-info
      [guardianToInvite]="invite"
      (cancelInvite)="onCancel(invite)">
    </se-po-guardian-invite-info>
  </div>
}
<se-fe-button
  class="invite-button"
  seFeDataEmphasis="high"
  [seFeDataFullWidth]="true"
  (click)="onContinue()">
  {{ translationKey + 'BUTTONS.continue' | translate }}
</se-fe-button>
@if (canInviteGuardians) {
  <se-fe-button
    class="invite-button"
    [seFeDataFullWidth]="true"
    (click)="onInvite()">
    {{ translationKey + 'BUTTONS.invite_another' | translate }}
  </se-fe-button>
}
